import { call, put } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { whiteboardSettingPushed } from 'features/whiteboard/actions';
import { whiteboardSettingsPushed } from 'features/whiteboard/whiteboardSlice';
import { board } from 'utils/whiteboard/BoardStateManager';
import {
  buildSettingRecord,
  ParsedSetting,
  parseSetting,
  toSettings,
} from 'utils/whiteboard/settings';

export function* pushWhiteboardSettingSaga(action: ReturnType<typeof whiteboardSettingPushed>) {
  const canEditWhiteboard: boolean = yield call(hasPermissionsSaga, PermissionTypes.editWhiteboard);

  if (!canEditWhiteboard) {
    return;
  }

  const { key, value } = action.payload;

  // hold the local publish to the same validation the remote path applies, or the pusher
  // would end up on a theme every receiver rejected
  const setting: ParsedSetting | null = yield call(parseSetting, buildSettingRecord(key, value));
  if (!setting) {
    return;
  }

  if (!board.isWatching) {
    return;
  }

  yield call(board.setSetting, setting.key, setting.value);

  yield put(whiteboardSettingsPushed(toSettings([setting])));
}
